/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
/* eslint-disable no-unused-vars */
import {useEffect, useState} from 'react';
import {dlsIconColor} from '../theme/theme';
import {Color} from '../types/types';

/**
 * Defines the useIconColor hook which returns the icon color and size based
 * on the provided default values, if any.
 *
 * ```typescript
 *   import {useIconColor} from '@ion/dls/src/icons/useIconColor';
 *
 *   export const Icon = (props: IconProps) => {
 *     const iconColor = useIconColor(props);
 *     return (
 *       <svg width={props.size} height={props.size} viewBox='0 0 24 24' fill='none'>
 *         <path d='M10.484 18a1.313 1.313 0 100-2.625 1.313 1.313 0 000 2.625z'
 *          fill={iconColor}
 *          />
 *       </svg>
 *   };
 *
 * ```
 */
export const useIconColor = (color: Color) => {
  const [iconColor, setIconColor] = useState(color);
  useEffect(() => {
    setIconColor(color || dlsIconColor());
  }, [color]);
  return (iconColor as unknown) as string;
};
export default useIconColor;
